import { TasksType } from '../types/interfaces';

export const tasks: TasksType[] = [
  { name: 'Монтаж оборудования' },
  { name: 'Устранение неполадок' },
  { name: 'Ремонт вышки' },
  { name: 'Подключение клиента' },
  { name: 'Установка программного обеспечения' },
  { name: 'Устранение неполадок на линии' },
  { name: 'Обрыв кабеля' },
  { name: 'Увеличение мощности' },
  { name: 'Подключение к сети 1 ' },
  { name: 'Подключение к сети 2' },
  { name: 'Подключение к сети 3' },
  { name: 'Подключение к сети 4' },
  { name: 'Подключение к сети 5' },
  { name: 'Подключение к сети 6' },
  { name: 'Подключение к сети 7' },
  { name: 'Подключение к сети 8' },
  { name: 'Подключение к сети 9' },
  { name: 'Подключение к сети 10' },
  { name: 'Подключение к сети 11' },
  { name: 'Подключение к сети 12' },
  { name: 'Подключение к сети 13' },
  { name: 'Подключение к сети 14' },
  { name: 'Подключение к сети 15' },
  { name: 'Подключение к сети 16' },
  { name: 'Подключение к сети 17' },
  { name: 'Подключение к сети 18' },
  { name: 'Подключение к сети 19' },
  { name: 'Подключение к сети 20' },
  { name: 'Подключение к сети 21' },
  { name: 'Подключение к сети 22' },
  { name: 'Подключение к сети 23' }
];
